import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import { RouterMatchSchema, ServerResponseSchema } from 'app'
import { getStatePlayer } from 'players'
import { withMatch } from 'utils'

import * as actions from '../../actions/player'
import PlayerForm from '../../components/PlayerForm'

class PlayerScreenForm extends PureComponent {
  componentDidMount() {
    const { playerId } = this.props.match.params
    if (this.props.player.key !== playerId) {
      this.props.playerFetch(playerId)
    }
  }

  componentWillUnmount() {
    this.props.playerFetchCanceled()
  }

  render() {
    return (
      <div>
        {!!this.props.player.data?.[0] && (
          <PlayerForm onCancel={Function.prototype} onSave={Function.prototype} player={this.props.player.data?.[0]} />
        )}
      </div>
    )
  }
}

PlayerScreenForm.propTypes = {
  match: RouterMatchSchema.isRequired,
  player: ServerResponseSchema.isRequired,
  playerFetch: PropTypes.func.isRequired,
  playerFetchCanceled: PropTypes.func.isRequired,
}

PlayerScreenForm.defaultProps = {}

export class Pure extends PlayerScreenForm {}

Pure.displayName = 'PlayerScreenForm'

export default connect(
  (state) => ({
    player: getStatePlayer(state),
  }),
  {
    playerFetch: actions.playerFetch,
    playerFetchCanceled: actions.playerFetchCanceled,
  },
)(withMatch(PlayerScreenForm))
